/* N.B. These codes need to reflect app/src/Entity/Interfaces/FileTypeInterface.php in the api project */

const INVOICE_BATCH_FILE_TYPES = {
  FILE_TYPE_INVOICE_ORIGINAL: 1,
  FILE_TYPE_INVOICE_CURRENT_CHECKED_AND_PRICED: 10,
  FILE_TYPE_INVOICE_PREVIOUS_CHECKED_AND_PRICED: 20,
};

export default INVOICE_BATCH_FILE_TYPES;
